import { ValidateEmail, warn } from "@swivl-mono/helpers";
import { Button, ButtonColor, ButtonSize, Input, PasswordInput } from "@swivl-mono/ui";
import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import AccountModel from "../../Models/Account/AccountModel";
import { LocalStorageHelper } from "../../Models/LocalStorage/LocalStorageHelper";
import { NavBar } from "../../Models/NavBar/NavBar.Model";
import Logo from "./Assets/SwivlLogo.png";
import "./Login.View.scss";

export function LoginView() {
  const { loginError } = AccountModel.useState();
  const [queryParams] = useSearchParams();
  const [username, setUsername] = useState(queryParams?.get("email") ?? "");
  const redirect = queryParams?.get("redirect") ?? undefined;
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    LocalStorageHelper.removeItem("botId");
    NavBar.set(null, <NavBar.Component.Logo />, null);
  }, []);

  const loginClicked = () => {
    var validEmail = ValidateEmail(username.toLowerCase());
    if (validEmail === false) {
      setErrorMsg("Please enter a valid email");
      return;
    }
    setIsLoading(true);
    setErrorMsg("");
    AccountModel.logIn(username.toLowerCase(), password, navigate, true, redirect).catch((error: Error) => {
      warn("ERRRRR", error);
      if (typeof error === "string") {
        setErrorMsg(error);
      } else if (error.message) {
        setErrorMsg(error.message);
      } else {
        setErrorMsg("Error Logging In");
        warn("Error Logging In", error);
      }
      setIsLoading(false);
    });
  };

  useEffect(() => {
    if (loginError) {
      setErrorMsg(loginError);
      setIsLoading(false);
    } else if (errorMsg.length > 0) {
      setErrorMsg("");
    }
  }, [loginError]);
  return (
    <div className="SignUpView flex flex-col items-center">
      <img src={Logo} alt="Swivl Logo" className="mx-auto mb-8 w-1/2" />
      <div className="container mx-auto">
        <div className="loginContent mx-auto">
          <h1 className="mb-5 text-center text-lg">Login</h1>
          <div className="mb-4 flex flex-col gap-2">
            <Input
              label="Email"
              value={username}
              name="username"
              type="email"
              autoComplete="email"
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  if (username.length > 1 && password.length > 1) {
                    loginClicked();
                  } else {
                    document.getElementById("passwordInput")?.focus();
                  }
                }
              }}
            />
            <PasswordInput
              id="passwordInput"
              label="Password"
              value={password}
              name="password"
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") loginClicked();
              }}
            />
          </div>
          {errorMsg && <div className="mb-3 text-sm text-red-500">{errorMsg}</div>}
          <div className="mb-5">
            <Button fullWidth onClick={loginClicked} loading={isLoading} color={ButtonColor.ORANGE} size={ButtonSize.LARGE}>
              Log In
            </Button>
          </div>

          <div className="loginContent mx-auto text-center">
            <Link className="forgotText w-full text-center" to={"/forgot-password?email=" + encodeURIComponent(username)}>
              Forgot?
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
